import { render, staticRenderFns } from "./SalesReturnDiscrepancy.vue?vue&type=template&id=dfaa68aa&"
import script from "./SalesReturnDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./SalesReturnDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports